const PageHeader = ({ title, subtitle, actions, className = '' }) => (
  <div className={`page-header ${actions ? 'flex items-center justify-between' : ''} ${className}`}>
    <div>
      <h1 className="page-title">{title}</h1>
      {subtitle && <p className="page-subtitle">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

export default PageHeader;
